import React from 'react';
import { useRouter } from 'next/router';

export const useOpenTaskDialog = () => {
  const router = useRouter();

  return React.useCallback(
    (taskId: string) => {
      if (taskId !== router.query.task) {
        // Don't mutate router.query - create a new object
        router.push(
          {
            pathname: router.pathname,
            query: { ...router.query, task: taskId },
          },
          undefined,
          { shallow: true }
        );
      }
    },
    [router]
  );
};
